import { Typography } from "@/shared/ui/atoms"
import Image from "next/image"
import type { CSSProperties, ReactNode } from "react"

interface SummaryCardProps {
  thumbnail: string
  title: string
  children: ReactNode
  className?: string
}

const SummaryCard = ({ thumbnail, title, children, className }: SummaryCardProps) => {
  return (
    <div className={`flex gap-3 pt-4 pb-4 ${className}`}>
      <div
        className="relative shrink-0 dynamic-size rounded-md min-w-[80px] min-h-[80px] overflow-hidden"
        style={{ "--width": 80, "--height": 80 } as CSSProperties}
      >
        <Image
          src={thumbnail}
          alt={title}
          fill
          className="object-cover"
          sizes="(max-width: 600px) 21.33vw, 128px"
        />
      </div>
      <div className="flex flex-col gap-1">
        <Typography size={15} className="text-gray-900 font-semibold">{title}</Typography>
        {children}
      </div>
    </div>
  )
}

export default SummaryCard